// @flow
import * as React from 'react';
import { graphql } from 'react-apollo';
import idx from 'idx';

import CurrentUser from 'auth/CurrentUser';
import errorLogger from 'utils/errorLogger';
import SettingsActions from 'actions/SettingsActions';

import ROLE_PICKER_ME_QUERY from './queries/RolePickerMeQuery.gql';

import type { RolePickerMeQuery } from './queries/__generated__/RolePickerMeQuery';

type Props = {
  children: Function,
  data: ReactApolloData<RolePickerMeQuery>,
};

type State = {
  showAdminOption: boolean,
};

class RolePickerContainer extends React.Component<Props, State> {
  state = {
    showAdminOption: false,
  };

  componentDidMount() {
    const onGeoReceived = geo => {
      if (!geo.country_code || geo.country_code === 'US') {
        this.showAdminOption();
      }
    };

    SettingsActions.getGeo()
      .then(onGeoReceived)
      .catch(errorLogger('Get geolocation settings failure'));
  }

  showAdminOption = () => {
    this.setState({ showAdminOption: true });
  };

  render() {
    const { data } = this.props;

    if (!CurrentUser.isSignedIn()) {
      return null;
    }

    const hasFeature = CurrentUser.getUser().hasFeature('2019.jan.web.paid_canada');
    const showAdminOption = hasFeature
      ? idx(data, _ => _.me.permissions.canSelectAdminRole)
      : this.state.showAdminOption;

    return this.props.children({
      showAdminOption,
      loading: idx(data, _ => _.loading),
    });
  }
}

const withData = graphql(ROLE_PICKER_ME_QUERY);

export { RolePickerContainer };

export default withData(RolePickerContainer);
